import { useEffect, useState } from 'react';
import { Outlet, Link, NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AccessibilityWidget from './AccessibilityWidget';
import './Layout.css';

export default function Layout() {
  const { user, isAdmin, loading, signOut } = useAuth();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  return (
    <div className="layout">
      <header className="layout-header">
        <div className="layout-header-inner">
          <Link to="/" className="layout-brand">
            <span className="layout-brand-name">Regional Events Calendar</span>
            <span className="layout-brand-tag">Local Jobs NENW</span>
          </Link>
          <button
            type="button"
            className="layout-menu-toggle"
            aria-expanded={menuOpen}
            aria-controls="layout-main-nav"
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span className="layout-menu-toggle-line" />
            <span className="layout-menu-toggle-line" />
            <span className="layout-menu-toggle-line" />
            <span className="visually-hidden">Toggle navigation</span>
          </button>
          <nav id="layout-main-nav" className={`layout-nav ${menuOpen ? 'is-open' : ''}`} aria-label="Main">
            <div className="layout-nav-primary">
              <NavLink to="/" end className={({ isActive }) => `layout-nav-link ${isActive ? 'is-active' : ''}`}>
                Home
              </NavLink>
              <NavLink to="/events" className={({ isActive }) => `layout-nav-link ${isActive ? 'is-active' : ''}`}>
                Events
              </NavLink>
              <NavLink to="/about" className={({ isActive }) => `layout-nav-link ${isActive ? 'is-active' : ''}`}>
                About
              </NavLink>
            </div>
            <div className="layout-nav-secondary">
              <a
                href="https://www.localjobsnenw.com.au"
                target="_blank"
                rel="noreferrer"
                className="layout-nav-link"
              >
                Local Jobs NENW
              </a>
              {loading ? (
                <span className="layout-loading">…</span>
              ) : user ? (
                <>
                  <NavLink to="/dashboard" className={({ isActive }) => `layout-nav-link ${isActive ? 'is-active' : ''}`}>
                    Dashboard
                  </NavLink>
                  {isAdmin && (
                    <NavLink to="/admin" className={({ isActive }) => `layout-nav-link ${isActive ? 'is-active' : ''}`}>
                      Admin
                    </NavLink>
                  )}
                  <NavLink to="/submit" className={({ isActive }) => `layout-nav-link ${isActive ? 'is-active' : ''}`}>
                    Submit event
                  </NavLink>
                  <button type="button" className="layout-btn layout-signout" onClick={() => signOut()}>
                    Sign out
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" className="layout-btn layout-btn-ghost">
                    Log in
                  </Link>
                  <Link to="/signup" className="layout-btn layout-btn-primary">
                    Sign up
                  </Link>
                </>
              )}
            </div>
          </nav>
        </div>
      </header>
      <main className="layout-main">
        <Outlet />
      </main>
      <footer className="layout-footer">
        <div className="layout-footer-inner">
          <div className="layout-footer-links">
            <Link to="/privacy" className="layout-footer-link">
              Privacy Policy
            </Link>
            <Link to="/cookies" className="layout-footer-link">
              Cookie Policy
            </Link>
          </div>
          <a href="https://www.hldgroup.org" target="_blank" rel="noreferrer" className="layout-footer-built-by">
            <span className="layout-footer-label">Built By</span>
            <img src="/HLD.png" alt="HLD" className="layout-footer-logo" />
          </a>
        </div>
      </footer>
      <AccessibilityWidget />
    </div>
  );
}
